module.exports = __webpack_public_path__ + "img/85_8.d26689e9.png";